import { z } from "zod";

import { OAuthServiceSchema } from "./oauth-start.schema";

/**
 * COMPLETE OAuth flow - Request body.
 *
 * The provider redirects the consenting browser to the backend callback, which
 * forwards `code` and `state` to the frontend unchanged; the frontend sends them
 * here under its own sign-in. `state` is the handshake id the authorize URL
 * carried — a database-minted uuid, so nothing else is accepted.
 */
export const OAuthCompleteBodySchema = z.strictObject({
  service: OAuthServiceSchema,
  code: z.string().min(1),
  state: z.uuid()
});

/** COMPLETE OAuth flow - the connection the flow wrote, for the opener window. */
export const OAuthCompleteResponseSchema = z.object({
  service: OAuthServiceSchema,
  connectionId: z.string().min(1),
  handshakeId: z.string().min(1),
  /** The `flowId` the start carried in `settings`, or `null` when it carried none. */
  flowId: z.string().nullable()
});

export type OAuthCompleteBody = z.infer<typeof OAuthCompleteBodySchema>;
